import { Box, Flex, Image, Text } from '@chakra-ui/react'
import type { Insurer } from 'BrokerTsLib/src/enums'
import React from 'react'

import { getLogo } from '../../utils/companiesLogos'

export const IndividualCompany = ({
  children,
  id,
  name,
}: {
  children: React.ReactNode
  id: Insurer
  name: string
}) => {
  const logoImage = getLogo(id)

  return (
    <Box sx={{ display: 'grid', gap: 4 }}>
      <Flex sx={{ gap: 4, alignItems: 'center', fontWeight: 'medium' }} as="header">
        {logoImage && <Image src={logoImage} alt={name} width='64px' maxH='48px' />}

        <Text as="p">{name}</Text>
      </Flex>

      {children && children}
    </Box>
  )
}
